import React from 'react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabContent, Nav } from 'reactstrap'
import { getTabs } from '../../utils'
import AppObjectTab from '../AppObjectTab/AppObjectTab'
import AppObjectPane from '../AppObjectPane/AppObjectPane'
import AppObjectCard from '../AppObjectCard/AppObjectCard'
import AppObjectHistoryCard from '../AppObjectCard/AppObjectHistoryCard'
import AppObjectHistoryTab from '../AppObjectHistoryTab/AppObjectHistoryTab'
import AppObjectHistoryPane from '../AppObjectPane/AppObjectHistoryPane'
import './AppObjectBody.css'
import { ACTION_TYPE, OBJECT_VIEW_STYLE } from '../../constants'

// this component can be called with the following prop values:
//
// READ ONLY DISPLAY OF EXISTING OBJECT
// object = {object}, action = null, objectType = null
//
// ACTION PERFORMED ON OBJECT
// object = {object}, action = {action}, objectType = null
//
// SUBMIT ACTION
// object = null, action = {submit}, objectType = {objectType}
//

export default function AppObjectBody(props) {
  const { object, parentObjectId, action, objectType, formInputs, viewStyle } = props
  console.log('AppObjectBody rendered: ', props)

  let objType = objectType
  let parent = null

  if (object) {
    objType = object.type
    parent = object.parent
  }
  // getTabs will return a default tab if no form tabs are defined
  let viewDetail = false
  if (parent) {
    viewDetail = true
  }

  const formTabs = getTabs(objType, action, parent, viewDetail)
  const initialTab = formTabs[0].name
  const [activeTab, setActiveTab] = useState(initialTab)
  const location = useLocation()
  const printView = location.pathname.includes('printView') ? true : false

  const tabs = []
  const panes = []
  const cards = []
  formTabs.forEach((formTab) => {
    tabs.push(<AppObjectTab key={formTab.id} object={object} action={action} tab={formTab} activeTab={activeTab} setActiveTab={setActiveTab} />)
    panes.push(<AppObjectPane key={formTab.id} object={object} parentObjectId={parentObjectId} action={action} formInputs={formInputs} tab={formTab} />)
    cards.push(<AppObjectCard key={formTab.id} object={object} parentObjectId={parentObjectId} action={action} formInputs={formInputs} tab={formTab} />)
  })

  // only display the history tab if we are not submitting and not a child ref list
  if (!parentObjectId) {
    if (!action || parseInt(action.type.id, 10) !== ACTION_TYPE.submit) {
      if (!printView) {
        tabs.push(<AppObjectHistoryTab key='history' activeTab={activeTab} setActiveTab={setActiveTab} />)
        panes.push(<AppObjectHistoryPane key='history' history={object.history} />)
        cards.push(<AppObjectHistoryCard key='history' history={object.history} />)
      }
    }
  }

  let objectView =
    <React.Fragment>
      <Nav tabs className='mynav' data-cy='mynav' >
        {tabs}
      </Nav>
      <TabContent className="app-object-tab-content" activeTab={activeTab}>
        {panes}
      </TabContent>
    </React.Fragment>

  if (viewStyle === OBJECT_VIEW_STYLE.card) {
    objectView =
      <React.Fragment>
        {cards}
      </React.Fragment>
  }

  return (
    <div className="app-object-body-container">
      {objectView}
    </div>
  )
}
